import React, { useEffect, useState } from "react";

const DataTesti = [
    {
        id: 1,
        Name: "Carlos M. – Empresario",
        Description: "Antes tenía muchas ideas, pero poca claridad. A través del proceso logré organizar mi visión, fortalecer mi mentalidad y tomar decisiones con más seguridad. Hoy siento que tengo control y dirección en mi negocio."
    },
    {
        id: 2,
        Name: "Laura G. – Profesional independiente",
        Description: "Este proceso me ayudó a cambiar mi forma de pensar. Pasé de la duda constante a tener más confianza en mí misma y en lo que quiero construir."
    },
    {
        id: 3,
        Name: "Andrés R. – Líder de equipo",
        Description: "No solo trabajé en mí, también entendí cómo liderar mejor a mi equipo. Hoy tenemos más enfoque, mejor comunicación y resultados más claros."
    },
    {
        id: 4,
        Name: "Mariana P. – Emprendedora",
        Description: "Lo más valioso fue la claridad. Dejé de sentirme perdida y empecé a tomar acción con dirección. Eso cambió completamente mi forma de trabajar."
    }
];

function Testimonios() {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % DataTesti.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="w-full max-w-2xl mx-auto overflow-hidden">
            <h1 className="text-center text-2xl font-times font-bold">
                Testimonios
            </h1>
            <div
                className="flex transition-transform duration-700 ease-in-out"
                style={{ transform: `translateX(-${index * 100}%)` }}
            >
                {DataTesti.map((T) => (
                    <div key={T.id} className="min-w-full p-4">
                        <div className=" rounded-xl shadow-lg shadow-slate-400 p-6 text-center">
                            <p className="text-justify text-xl font-times font-bold mb-2">{T.Name}</p>
                            <p className="text-justify text-xl font-times  mb-2">{T.Description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}


export default Testimonios;